import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'temp-work-edit-availability-dialog',
  templateUrl: 'availability-selection-dialog.html',
  styleUrls: ['availability-selection-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilitySelectionDialogComponent {
  data$ = new BehaviorSubject<
    | {
        personName: string;
        restWarning?: string;
        note?: string;
      }
    | undefined
  >(undefined);

  constructor(
    public dialogRef: MatDialogRef<AvailabilitySelectionDialogComponent>,
    public permissionsService: PermissionsService,
    @Inject(MAT_DIALOG_DATA)
    data: {
      personName: string;
      restWarning?: string;
      note?: string;
    },
  ) {
    this.data$.next(data);
  }

  get data() {
    return this.data$.value;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
